import React, { useState } from 'react';
import { Form, Button, Modal, Row, Col } from 'react-bootstrap';
import './Followups.css';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField } from '@mui/material';

const StageModal = ({
    showModal,
    handleClose,
    newStage,
    handleInputChange,
    handleAddStage,
    stageMaster,
    setnewStage,
    prevData,
    mode,
    editMode,
    setNextDate,
    setOpendate,
    setClosedate,
    setNextCloseDate
}) => {
    const [errors, setErrors] = useState({ openDate: '', closingDate: '', stage: '' });
    const today = dayjs().format('YYYY-MM-DD'); // Today's date in YYYY-MM-DD format

    const formatDate = (date) => date ? dayjs(date, 'DD/MM/YYYY').format('DD/MM/YYYY') : '';

    const handleDateChange = (newValue, name) => {
        const formattedDate = newValue ? dayjs(newValue).format('DD/MM/YYYY') : '';      

        if (name === "openDate") {
            setOpendate(newValue);
        }

        if (name === "closingDate") {
            setClosedate(newValue);
        }
        if (name === "nextStartDate") {
            setNextDate(newValue)
        }
        if (name === "nextCloseDate") {
            setNextCloseDate(newValue)
        }
        handleInputChange({ target: { name, value: formattedDate } });
    };

    const handleStageChange = (e) => {
        const selectedStage = e.target.value;
        handleInputChange(e);

        const stageData = stageMaster.find(stage => stage.descript === selectedStage);
        const percentage = stageData?.cloPrcnt || '';
        const stageId = stageData?.stepId || '';

        // setnewStage(prev => ({
        //     ...prev,
        //     percentage,
        //     stageId,
        //     nextStageId: stageId // Set nextStageId here
        // }));
        setnewStage(prev => ({
            ...prev,
            // Set properties based on mode
            ...(mode 
                ? { stage: selectedStage, stageId } 
                : { nextStage: selectedStage, nextStageId: stageId }
            ),
            percentage
        }));

        if (selectedStage) {
            setErrors(prevErrors => ({ ...prevErrors, stage: '' }));
        }
    };

    const getPercentageClass = (percentage) => {
        if (percentage < 30) return 'percentage-low';
        if (percentage < 70) return 'percentage-medium';
        return 'percentage-high';
    };

    const validateForm = () => {
        const newErrors = {
            openDate: '',
            closingDate: '',
            stage: '',
            nextStartDate: '',
            // nextCloseDate: '' 
        };

        const dateField = !mode ? 'nextStartDate' : 'openDate';
        // const CloseDateField = !mode ? 'nextCloseDate' : 'closingDate';
        if (!newStage[dateField]) {
            newErrors[dateField] = 'Start Date is required.';
        }
        // if (!newStage[CloseDateField]) {
        //     newErrors[CloseDateField] = 'Close Date is required.';
        // }
        if (!newStage.stage) {
            newErrors.stage = 'Stage is required.';
        }

        setErrors(newErrors);
        return !newErrors[dateField] && !newErrors.stage;
    };

    const handleFormSubmit = () => {
        if (validateForm()) {
            handleAddStage();
            handleClose();
        }
    };
    

    const lastPrevData = (prevData && prevData.length > 0) ? prevData[prevData.length - 1] : null;

    // Condition to check if editMode is true and the last prevData.lineId matches newStage.id
    const shouldShowComments = lastPrevData?.lineId === newStage.id;
    
    return (
        <Modal show={showModal} onHide={handleClose} className="crmstage-modal" centered>
            <div className="crmmodal-content">
                <div className="crmmodal-header">
                    <Button variant="close" onClick={handleClose} />
                </div>
                <div className="crmmodal-body">
                    <Form>
                        <Row>
                            <Col xs={6}>
                                <Form.Group controlId="formStartDate">
                                    <Form.Label>
                                        Start Date <span className="mandatory">*</span>
                                    </Form.Label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            // name="openDate"
                                            name={!mode ? "nextStartDate" : "openDate"}
                                            value={newStage[!mode ? 'nextStartDate' : 'openDate'] ? dayjs(newStage[!mode ? 'nextStartDate' : 'openDate'], 'DD/MM/YYYY') : null}
                                            onChange={(newValue) => handleDateChange(newValue, !mode ? 'nextStartDate' : 'openDate')}
                                            // value={newStage.openDate ? dayjs(newStage.openDate, 'DD/MM/YYYY') : null}
                                            // onChange={(newValue) => handleDateChange(newValue, 'openDate')}
                                            minDate={dayjs(today)} // Disable previous dates
                                            disabled={editMode && shouldShowComments} // Disabled in Edit mode
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    className="form-control custom-form-control"
                                                    disabled={editMode} // Disable the TextField in `editMode`
                                                />
                                            )}
                                            format="DD/MM/YYYY"
                                        />
                                    </LocalizationProvider>
                                    {errors[!mode ? 'nextStartDate' : 'openDate'] && (
                                        <div className="error-message crmerror-message">
                                            {errors[!mode ? 'nextStartDate' : 'openDate']}
                                        </div>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col xs={6}>
                                <Form.Group controlId="formClosingDate">
                                    <Form.Label>Closing Date</Form.Label> {/* Removed mandatory asterisk */}
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            name={!mode ? "nextCloseDate" : "closingDate"}
                                            value={newStage[!mode ? 'nextCloseDate' : 'closingDate'] ? dayjs(newStage[!mode ? 'nextCloseDate' : 'closingDate'], 'DD/MM/YYYY') : null}
                                            onChange={(newValue) => handleDateChange(newValue, !mode ? 'nextCloseDate' : 'closingDate')}
                                            minDate={dayjs(today)} // Disable previous dates
                                            disabled={editMode && shouldShowComments}
                                            renderInput={(params) => (
                                                <TextField
                                                {...params}
                                                className="form-control custom-form-control"
                                                disabled={editMode} //  Disable the TextField in `editMode`
                                            />
                                            )}
                                            format="DD/MM/YYYY"
                                        />
                                    </LocalizationProvider>
                                    {errors.closingDate && <div className="error-message">{errors.closingDate}</div>}
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <Form.Group controlId="formStage">
                                    <Form.Label>
                                        Stage <span className="mandatory">*</span>
                                    </Form.Label>
                                    <div className="dropdown-wrapper">
                                        <Form.Control
                                            as="select"
                                            name="stage"
                                            value={newStage.stage}
                                            onChange={handleStageChange}
                                            className="form-control custom-form-control"
                                            disabled={editMode && shouldShowComments}
                                        >
                                            <option value="">Select a stage</option>
                                            {stageMaster.map((stageOption) => (
                                                <option key={stageOption.stepId} value={stageOption.descript}>
                                                    {stageOption.descript}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </div>
                                    {errors.stage && <div className="error-message">{errors.stage}</div>}
                                </Form.Group>
                            </Col>
                            <Col xs={6}>
                                <Form.Group controlId="formPercentage">
                                    <Form.Label>Percentage</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="percentage"
                                        value={newStage.percentage}
                                        onChange={handleInputChange}
                                        className={`form-control custom-form-control ${getPercentageClass(newStage.percentage)}`}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Form.Group controlId="formRemarks">
                            <Form.Label>Remarks</Form.Label>
                            <Form.Control
                                type="text"
                                name="remarks"
                                value={newStage.remarks}
                                disabled={editMode && shouldShowComments}
                                onChange={handleInputChange}
                                className="form-control custom-form-control"
                            />
                         </Form.Group>
                         {shouldShowComments && (
                          <Form.Group controlId="formComments">
                          <Form.Label>Comments</Form.Label>
                          <Form.Control
                          type="text"
                          name="comments"
                          value={newStage.comments || ''}  
                          onChange={handleInputChange}
                          className="form-control custom-form-control"
                           />
                         </Form.Group>
                         )}
                    </Form>
                </div>
                <div className="crmmodal-footer">
                    <Button variant="primary" onClick={handleFormSubmit} className="btnadd">
                        {editMode ? 'Update': 'Add Stage'}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default StageModal;

